export const giThemeMinCss = `
:root {
    --font-family: rubik,sans-serif;
    --primary-blue-color: #2276e3;
    --base-text-color: #222;
    --black-color: #222;
    --darkGrey-color: #717171;
    --red-Text: #a21517;
    --primary-btn-color1: #ff6d38;
    --primary-btn-color2: #ff6d38;
    --font-bold: 500;
    --font-bolder: 600;
}

body, html {
  background: #e5eef4;
  color: rgba(0,0,0,.85);
  padding: 0;
  margin: 0;
  font-family: var(--font-family,'Lato' sans-serif) !important;
  font-weight: 400;
}

.marginB5 {
  margin-bottom: 5px;
}

.marginT10 {
  margin-top: 10px;
}

.marginT20 {
  margin-top: 20px;
}

.isGi .modify-search-header,
.isGi .hsw.v2,
.isGi .fareTypeWrapper,
.isGi .bgGradient,
.isGi .fakeDivHeight10 {
  background-image: linear-gradient(95deg, #fe6d38 1%, #dc7a22 92%);
}

.isGi .groupBookingCard {
  background-color: rgb(0, 162, 173);
  border-color: rgb(0, 162, 173);
}

.isGi .commonHeader .header-sticky-nope {
  z-index: 13 !important;
}

.isGi .modify-search-input-box,
.isGi .hsw .hsw_inputBox {
  background: #ffffff;
  border-radius: 8px;
  min-height: 51px;
  margin-right: 8px;
}

.isGi .hsw .width160 {
  width: 155px;
}

.isGi .hsw .lbl_input {
  margin: 0;
}

.isGi .modify-search-input-field {
  color: black;
}

.isGi .modify-search-input-box .blueText,
.isGi .hsw .blueText {
  color: #b0b0b0;
}

.isGi .multiDropDownVal,
.isGi .hsw .hsw_inputField.whiteText {
  color: #222222;
  font-weight: 500;
  padding: 2px 9px;
}

.isGi .fareTypeOptions li {
  padding: 6px 8px;
  background-color: rgba(255, 255, 255, 0.16);
  font-size: calc(var(--font-scale, 1) * 14px);
}

.isGi .fareTypeOptions li.active {
  background-color: rgba(255, 255, 255, 0.32);
}

.isGi .fareTypeOptions .radioSelect {
  border: 2px solid #ffffff;
  width: 22px;
  height: 22px;
}

.isGi .fareTypeOptions li.active .radioSelect::before {
  left: 3px;
  top: 3px;
  width: 12px;
  height: 12px;
  border-radius: 30px;
  background: #ffffff;
}

.isGi .fareTypeOptions li.active .radioSelect {
  background: none;
  position: relative;
  border: 2px solid #ffffff;
}

.isGi .flight-list-container .primaryBtn {
  background-image: linear-gradient(97deg, #f37638, #f37638 130%)!important;
  color: #ffffff;
  border-radius: 2px;
}

.isGi .ViewFareBtn {
  border-radius: 4px;
  background-color: #ff6d38;
  padding: 6px 4px;
  color: #ffffff;
  border: none;
}

#searchButton,
.isGi .viewFareBtnCol>button {
  background-image: linear-gradient(97deg, #f37638, #f37638 130%);
  border-radius: 4px;
  color: #ffffff;
}

.isGi .filterWrapper {
  background: #ffffff;
  border-radius: 6px;
}

.isGi .filtersOuter {
  background: none;
}

.isGi .makeFilterSticky {
  border-radius: 6px;
}

.isGi .listingRhs .whiteBg {
  background: none;
}

.isGi .listingCard {
  border-radius: 7px;
  border: none;
  margin-top: 10px;
  margin-bottom: 0;
}

.isGi .clusterTabs {
  background: #ffffff;
  margin-top: -12px;
  border-radius: 10px;
}

.isGi .clustTabs {
  background-image: linear-gradient(#fe6d38,#dc7a22);
}

.isGi #weeklyFare {
  border-radius: 0;
  position: relative;
}

.isGi #weeklyFare .glider-next {
  border-radius: 0;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  width: 35px;
  box-shadow: none;
}

.isGi #weeklyFare .glider-prev {
  border-radius: 0;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  width: 35px;
  box-shadow: none;
}

.isGi #weeklyFare .glider-next.disabled,
.isGi #weeklyFare .glider-prev.disabled {
  opacity: 1;
  color: #ffffff;
  cursor: default;
}

.isGi .sortTabsWrapper {
  padding: 30px 16px 10px 10px;
  margin: 0;
}

.isGi .clusterDesc {
  margin: 0;
}

.isGi .modify-search-header-components .searchBtn,
.isGi .hsw .hsw_searchButton {
  border-radius: 8px;
  background-color: #f7f7f7;
  color: #2276e3;
  background-image: none;
  padding: 11px 0;
}

.isGi .hsw .btnApply {
  border-radius: 8px;
  background-color: #f7f7f7;
  color: #2276e3;
  background-image: none;
}

.isGi .blueText {
  color: #2276e3;
}

.isGi .primaryCheckbox input[type="checkbox"]:checked ~ .box,
.isGi .rangeslider-horizontal .rangeslider__fill {
  background: #2276e3;
}

.isGi .filterTimeSlots.slotSelected {
  background-color: #e5f3ff;
  color: #2276e3;
}

.isGi .checkBlockIcon {
  width: 23px;
  height: 23px;
}

.isGi .rangeslider-horizontal .rangeslider__handle {
  border: 1px solid #2276e3;
  box-shadow: none;
}

.isGi button.disable-btn {
  height: 50px;
  border-radius: 8px;
  background: #E6E6E6;
}

.isGi .disable-btn-txt {
  color: #b0b0b0;
}

.isGi .weeklyFareItems.activeDate {
  border-bottom: 3px solid #2276e3;
  color: #2276e3;
}

.isGi .splitviewSticky {
  border-radius: 6px;
  background-color: #222222;
}

.isGi .skyBlueText {
  color: #368eff;
}

.isGi .paneView {
  background: none;
  box-shadow: none;
}

.isGi .splitViewListing:last-child .listingCard {
  margin-bottom: 10px;
}

.isGi .topSectionPaneView {
  background: #ffffff;
  padding-bottom: 10px;
  border-radius: 8px;
}

.isGi .splitViewListing input:checked ~ .listingCard,
.isGi .splitViewListing.checked .listingCard {
  border-radius: 6px;
  border: solid 1px #2276e3;
  background-color: #e5f3ff;
  background-image: inherit;
}

.isGi .ViewFareBtn .customArrow {
  border-color: #ffffff;
}

.isGi .linkText {
  color: #2276e3;
}

.isGi .hsw.v2 .multiCityWrapper {
  top: 67px;
  background-image: linear-gradient(95deg, #fe6d38 1%, #dc7a22 92%);
}

.isGi .hsw .hsw_inputField span {
  color: #222222;
  font-weight: 500;
}

.isGi .summary > .header {
  background-color: #222222;
  border-radius: 6px;
}

.isGi .customArrow {
  border-color: #2276e3;
}

.isGi .multiTripCount,
.isGi .doubbleArrowIcon,
.isGi .groupBookingCard .flight-count,
.isGi .fareTypeWrapper .lighterGreyText {
  color: #ffffff;
}

.isGi .addCityBtn {
  border-color: #ffffff;
  color: #ffffff;
}

.isGi .listingCardWrap .emi-option {
  margin: 0 0 20px;
  background: #ffffff;
  padding: 20px 0;
  border-radius: 8px;
}

.isGi .listingRhs .emi-option {
  background: #ffffff;
  padding: 10px 0;
  border-radius: 8px;
}

.isGi .emi-option .curved-container {
  margin-bottom: 0;
  border: solid 1px #e4e4e4;
}

.isGi .curved-container {
  margin: 0;

  /* margin-bottom: 20px; */
}

.isGi .listingCardWrap {
  border: none;
}

.isGi .pageStickyHder {
  background: linear-gradient(95deg, #fe6d38 1%, #dc7a22 92%);
}

.isGi .listingCard .alertMsg::before {
  content: "";
  height: 8px;
  width: 8px;
  margin-right: 5px;
  background: #18a160;
  border-radius: 50%;
  display: inline-block;
  margin-top: 3px;
}

.isGi .buttonSecondryInvert {
  padding: 5px 15px;
  min-width: 125px;
}

.isGi .flightDetailsOuter .nav-tabs .nav-item.show .nav-link,
.isGi .flightDetailsOuter .nav-tabs .nav-link.active {
  border: 1px solid #2276e3;
  background: #e5f3ff;
  color: #2276e3;
  border-radius: 4px;
}

.isGi .flightDetailsOuter .nav-tabs {
  border-radius: 4px;
}

.isGi .top-loading-bar.v2LoadingBar {
  background-image: linear-gradient(95deg, #fe6d38 1%, #dc7a22 92%);
}

.isGi .appliedFilter li {
  background: #e5f3ff;
  border: 1px solid #2276e3;
  border-radius: 4px;
  padding: 6px 8px;
  color: #2276e3;
  text-transform: inherit;
}

.isGi .sortTabHeadList {
  border: solid 1px #e4e4e4;
}

.isGi .sortTabHeadList.active {
  border: none;
}

.isGi .lockPriceTrigger {
  border-radius: 4px;
  background-color: #e5f3ff;
}

.isGi .sorterWraper {
  background: #ffffff;
  margin-top: -10px;
  padding-top: 30px;
  border-radius: 10px;
  padding-bottom: 15px;
}

.isGi .customRadioBtn input[type="radio"]:checked + .outer {
  border-color: #2276e3;
}

.isGi .customRadioBtn input[type="radio"]:checked + .outer .inner {
  background-color: #2276e3;
}

.isGi .arln-logo,
.isGi .multiairline {
  border-radius: 6px;
}

.isGi .clusterContent .emi-option {
  padding: 10px;
}

.isGi .ppInterstialPadding {
  padding: 2px 15px 2px 46px;
}

.isGi .toggle-button {
  border: none;
}

.isGi .knob {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  background: #ffffff;
  width: 22px !important;
  height: 22px !important;
}

.isGi .pageComponentsLinks ul li span {
  color: rgb(255 255 255 / 0.7);
}

.isGi .componentContainer {
  border-radius: 6px;
}

.isGi .mmtConnectlist li {
  margin-right: 25px;
}

.isGi .top-loading-bar .fillingLoader {
  background: #2276e3;
}

.isGi .top-loading-bar .fillingLoader .fillingLoaderShining {
  background-color: #3487f1;
}

.isGi .ppOverLayWrapper {
  background-image: linear-gradient(to bottom, #e5f3ff 0%, #ffffff 100%);
}

.isGi .ppOverLayWrapper .buttonSecondry,
.isGi .shadowList .actionBtn {
  border-radius: 4px;
  background-color: #ff6d38;
  padding: 6px 4px;
  color: #ffffff;
  border: none;
}

.isGi .shadowList .actionBtn {
  padding: 0 15px;
}

.isGi .groupBookingCard {
  margin-top: 10px;
  border-radius: 6px;
}

.isGi .group-placeholder .listingCard {
  border-radius: 6px;
}

.isGi .flightSelection li {
  padding: 9px 5px;
}

.isGi .faresContainer {
  padding-top: 24px;
}

.isGi .roundBackground.payLater {
  border: 2px solid #2276e3;
  background-color: #e5f3ff;
}

.isGi .scrollItem.seats {
  border-top-left-radius: 6px;
  background: linear-gradient(rgb(208, 232, 243) 0, rgb(196, 228, 242) 58%, rgb(132, 184, 216) 99%);
  box-shadow: none;
  border-top-right-radius: 6px;
}

.isGi .seatHeader {
  border: 1px solid rgb(228, 228, 228);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.isGi .persuationWrap {
  background: rgb(233, 252, 243);
  border: 1px solid rgb(228, 228, 228);
  border-radius: 2px;
  box-shadow: none;
}

.isGi .ancillaryContainer {
  background-color: #ffffff;
  border-radius: 6px;
}

.isGi .flightDetailsRow .airlineLogo {
  border-radius: 6px;
}

.isGi .mostPopularTag::after {
  background: #ff4a5c;
  right: -1px;
  width: 7px;
  top: 25px;
}

/*
body.isGi {
  background: #ffffff;
} */

.isGi .tyHdr.tySuccess {
  background-color: #e9fcf3;
}

.isGi .tyHdr.tyPending {
  background-color: #fff6e5;
}

.isGi .tyHdr.tyFailed {
  background-color: #ffeded;
}

.isGi .tyHdr.tyInprogress {
  background-color: #e5f3ff;
}

.isGi .tySuccess .tyHdr__heading {
  color: #156128;
}

.isGi .tyFailed .tyHdr__heading {
  color: #a21517;
}

.isGi .tyPending .tyHdr__heading {
  color: #714d0a;
}

.isGi .greyText,
.isGi .lightGreyText {
  color: #717171 !important;
}

.isGi .groupBookingCard .customArrow {
  border-color: #ffffff;
}

.isGi .sortTabIcon {
  background-color: #f4f4f4;
}

.isGi #weeklyFare .glider-prev::before,
.isGi #weeklyFare .glider-next::before,
.isGi #weeklyFare #leftArrow::before {
  box-shadow: none;
  border-color: #2276e3;
}

.isGi .pickDropCardLabel {
  box-shadow: none;
  border: 1px solid #e4e4e4;
}

.isGi .buttonSecondry {
  box-shadow: none;
}

.isGi .nearByAirportWrap {
  border: none;
}

.isGi .flDetailHdr {
  border-left: 4px solid #222222;
}

.isGi .flightItenary {
  background: rgba(247, 247, 247);
  border-radius: 6px;
}

.isGi .refundSection {
  border-radius: 6px;
  background-color: #e1e7ee;
}

.isGi .insuranceCard,
.isGi .insurancePlanWrapper .insuranceCard {
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  box-shadow: none;
}

.isGi .adultListWrapper,
.isGi .tvlrDtlsCard,
.isGi .flightDetailBlk {
  box-shadow: none;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
}

.isGi .alert-wrapper {
  box-shadow: none;
}

.isGi .scrollItem {
  box-shadow: none;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
}

.isGi .promoContent {
  border-radius: 6px;
  background: rgba(247, 247, 247);
}

.isGi .fareSummary,
.isGi .charityGIContainer,
.isGi .promocodeWrap {
  border-radius: 6px;
}

.isGi .button {
  border-radius: 5px;
}

.isGi .hsw .downArrow::before {
  content: "";
  width: 0;
  height: 0;
  border: none;
  position: absolute;
  top: inherit;
  z-index: 2;
}

.isGi .hsw .downArrow::after {
  width: 10px;
  height: 10px;
  border-top: 2px solid #b0b0b0;
  border-right: 2px solid #b0b0b0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(134deg);
  cursor: pointer;
  border-left: none;
  border-bottom: none;
}

.isGi .hsw .downArrow {
  right: 18% !important;
}

.isGi .viewFltDtlsCta {
  font-weight: 500;
  text-transform: uppercase;
}

.isGi .fliStopsSep {
  margin: -3px 0;
}

.isGi .infoStrip {
  background-color: #fff6e5;
}

.isGi .scrollTopTrigger .buttonSecondry {
  background: none;
}

.isGi .checkboxTitle .bgProperties {
  border-radius: 3px;
}

.isGi .commonCheckbox .box {
  border: 2px solid #b0b0b0;
}

.isGi .filterTimeSlots {
  height: 58px;
}

.isGi .sortbySection {
  background: #f4f4f4;
  border-radius: 6px;
}

.isGi .latoBlack {
  font-weight: 600;
}

.isGi #BILLING_ADDRESS label {
  margin-bottom: 0;
}

.isGi .okayButton {
  border-radius: 10px;
}

.isGi .premEconomySimple {
  background: none;
}

.isGi .premServicesSimple {
  padding: 10px 0;
}

.isGi .covidInsIcon {
  width: 58px;
}

.isGi .learnMoreContainer {
  justify-content: space-between;
  align-items: center;
}

.isGi .mealCounterWrap,
.isGi .mealAddBtn,
.isGi .baglistItem .qtyCounter {
  box-shadow: none;
  border: 1px solid #2276E3;
  border-radius: 4px;
}

.isGi .baglistItem .qtyCounter .qtyBtn {
  background: none;
  color: #2276E3;
}

.isGi .pickCard .optionWrapper {
  flex: 1;
}

.isGi .baglistItem .qtyCounter .qtyActions {
  color: #2276E3;
}

.isGi:not(.pwa) > #footer_block {
  display: flex;
  background: #16355c;
  padding: 30px 60px;
  margin-top: 10px;
  justify-content: space-between;
}

.isGi:not(.pwa) > #footer_block .footerHd.fb {
  font-size: 14px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: 600;
}

.isGi:not(.pwa) > #footer_block a {
  display: block;
  color: #fff;
}

#right_content_blocks > div div {
  background: #fff;
  padding:10px;
  border-bottom: 1px solid #e4e4e4;
}

#right_content_blocks > div h3{
  margin-top:10px
}

#right_content_blocks > div div:last-child {
  border-bottom: none;
}

#right_content_blocks > div {
  margin-top: 10px;
  margin-bottom: 25px;
}

.seo-header{
  width: 100%;
}

.listingRhs #seoContentTop b {
  color: inherit;
}

.isGi .alignItemsCenter {
  align-items: center;
}

.isGi .flexCol {
  display: flex;
  flex-direction: column;
}

.isGi .padB5 {
  padding-botoom: 0.5rem;
}

.isGi .justifyAround {
  justify-content: space-around;
}

.isGi .dF {
  display: flex
}

.isGi .pinkish_orange {
  color: #ff6d38;
}

.isGi .drGrey {
  color: #777777;
}

.isGi .topOverlayBtn {
  float: right;
  top: 0;
  position: fixed;
  right: 0%;
  z-index: 99999;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.isGi .topOverlayBg {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0px;
  left: 0px;
  background-color: #9696967a;
}

.isGi .topOverlayContent {
	 position: fixed;
	 z-index: 999999;
	 top: 0;
	 background-color: #f5fdff;
	 width: 100%;
	 padding: 2rem;
	 transition: all 0.5s ease 0s;
}

.isGi .topOverlayContent.topPos {
	 top: -500px;
}

.isGi .topOverlayContent .closePos {
	 margin-top: -1rem;
	 padding-right: 9rem;
	 position: absolute;
	 right: 0;
	 cursor: pointer;
	 font-size: 40px;
	 font-weight: 400;
}

.isGi .topOverlayContent .exclu {
	 font-size: 36px;
	 color: #555658;
}

.isGi .topOverlayContent .disc {
	 font-size: 32px;
	 color: #797a7b;
}

.isGi .topOverlayContent .offerRow {
	 width: 70%;
	 padding: 2rem 0;
}

.isGi .topOverlayContent .offer1 {
	 border: 1px solid #c9dde3;
	 border-radius: 5px;
	 width: 45%;
}

.isGi .topOverlayContent .offerHd {
	 background-color: #2980f7;
	 padding: 10px;
	 color: #fff;
	 border-top-left-radius: 5px;
	 border-top-right-radius: 5px;
}

.isGi .topOverlayContent .offerHdOrg {
	 background-color: #fd9460;
}

.isGi .topOverlayContent .flat {
	 font-size: 30px;
}

.isGi .topOverlayContent .instant {
	 font-size: 18px;
}

.isGi .topOverlayContent .offerBdy {
	 background-color: #fff;
	 padding: 10px;
	 border-bottom-left-radius: 5px;
	 border-bottom-right-radius: 5px;
}

.isGi .topOverlayContent .offerType {
	 font-size: 16px;
	 padding-bottom: 1rem;
}

.isGi .topOverlayContent .promoCopy {
	 padding-bottom: 1rem;
}

.isGi .topOverlayContent .promoCode {
	 border: 1px dashed #000;
	 padding: 4px 10px;
	 font-size: 14px;
	 margin-right: 7px;
	 color: #2980f7;
}

.isGi .topOverlayContent .copyCode {
	 background-color: #272727;
	 cursor: pointer;
	 padding: 6px 10px;
	 color: #fff;
	 border-radius: 7px;
	 text-transform: uppercase;
}

.isGi .topOverlayContent .copyCode.selected {
	 background-color: #939393;
}

.isGi .topOverlayContent .minTrans {
	 font-size: 14px;
}

.isGi .pad0 {
  padding: 0px!important;
}

.isGi .seoOnlyBlock .OfferWrap,
.isGi #seoRightBlock .OfferWrap,
.isGi #right_content_blocks .OfferWrap,
.isGi #right_content_blocks .OfferWrap .OfferContainer {
  margin: 0px;
  background: #fff;
  padding: 0px;
}

.isGi .seoOnlyBlock .OfferWrap,
.isGi #seoRightBlock .OfferWrap {
  padding-bottom: 20px!important;
}

.isGi .OfferWrap .OfferContainer .offerHeader{
  padding: 5px 0;
}

.isGi .OfferWrap .OfferContainer .offerValidityText{
  padding: 5px 0;
}

.isGi .buttonContainer {
  justify-content: center;
  display: flex;
}

.isGi .center {
  text-align: center;
}

.isGi .buttonContainer .viewDetailsBtn {
  background-color: #ff6d38;
  color: #ffffff;
  border: none;
}

.offerImageContainer{
  position: relative;
}

.offerImageContainer .arrows {
  background: transparent;
  cursor: pointer;
}

.offerImageContainer .giLeftArrow {
  position: absolute;
  box-shadwon: 0px 0px 1px darkgreen;
  left: 10px;
  bottom: 45%;
}

.offerImageContainer .giRightArrow {
  position: absolute;
  box-shadwon: 0px 0px 1px darkgreen;
  right: 10px;
  bottom: 45%;
}

.offerImageContainer .giLeftArrow,
.offerImageContainer .giRightArrow {
  background-color: #ffffff;
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  width: 22px;
  height: 22px;
}

.isGi.pwa .seoOnlyBlock > div:not(.content_blocks) {
  margin-top: 10px;
  margin-bottom: 25px;
}

.isGi.pwa .seoOnlyBlock > div:not(.content_blocks) > h3 {
  margin-bottom: 10px;
  color: #000;
  font-family: Lato-Bold,Arial,Helvetica,sans-serif;
  font-size: 20px;
}

.isGi.pwa .seoOnlyBlock > div:not(.content_blocks) > div:not(.content_blocks) {
  background-color: #fff;
  border-bottom: solid 1px #e8e8e8;
  padding: 15px 20px;
  font-size: 14px;
}

.isGi.pwa .footer_outer {
  width: 100%;
}

.isGi.pwa .flights_to_from_block a {
  font-size: 12px;
}

`;
